import { HttpInsuranceBenefitApprovalPaymentService } from '../../../service/http-insurance-benefit-payment-approval.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { PolicyBenefitPaymentDto } from '../../../service/dto-insurance';
import { ResultListDto, TicketInvoiceDto } from '../../../service/dto';
import { finalize, Subscription } from 'rxjs';
import { OnTableChange, TableColumn } from '../../../components/table/table.component';
import { Router } from '@angular/router';
import { HttpTicketInvoiceApprovalPaymentService } from '../../../service/http-ticket-invoice-approval.service';

@Component({
  selector: 'app-ticket-invoice-approval-list',
  standalone: false,
  templateUrl: './ticket-invoice-approval-list.component.html',
  styleUrl: './ticket-invoice-approval-list.component.scss'
})
export class TicketInvoiceApprovalListComponent implements OnInit, OnDestroy {
	data?: ResultListDto<TicketInvoiceDto>;
	pageIndex = 1;
	pageSize = 30;
	subscription = new Subscription();

	rejectionReason: string = '';
	loading = false;
	columnRef: TableColumn[] = [
		{ "title": "ID", "property": "id" },
		{ "title": "Workflow", "property": "workflow.label" },
		{ "title": "Recipient: Name", "cellRef": "recipientNameRef"},
		{ "title": "Payment Amount", "property": "benefitPaymentAmount" },
		{ "title": "Action", "cellRef": "actionRef" }
	];


	constructor(private httpService: HttpTicketInvoiceApprovalPaymentService, private router: Router) {
	}
	ngOnInit(): void {
		this.doFetchUploads({ pageIndex: this.pageIndex, pageSize: this.pageSize, filters: [] });
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	doFetchUploads(input: OnTableChange) {
		this.pageIndex = input.pageIndex;
		this.pageSize = input.pageSize;
		this.loading = true;

		this.httpService.getPendingInvoices(this.pageIndex, this.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.data = result;
			});
	}
	approve(input: TicketInvoiceDto) {
		input.approvalStatus = 'Approved';
	}
	reject(input: TicketInvoiceDto) {
		input.approvalStatus = 'Rejected';
	}
	onSubmit() {
		const list = this.data!.list.filter(item => item.approvalStatus === 'Rejected' || item.approvalStatus === 'Approved');
		this.httpService.doApproval(list, this.rejectionReason).subscribe(item => this.doFetchUploads({ pageIndex: 1, pageSize: this.pageSize, filters: [] }));
	}

	get hasRejections(): boolean {
		return this.data!.list.some(item => item.approvalStatus === 'Rejected') ?? false;
	}

	get approvedCount(): number {
		return this.data!.list.filter(item => item.approvalStatus === 'Approved').length ?? 0;
	}

	get rejectedCount(): number {
		return this.data!.list.filter(item => item.approvalStatus === 'Rejected').length ?? 0;
	}

	get pendingCount(): number {
		return this.data!.list.filter(item => item.approvalStatus === 'Pending').length ?? 0;
	}

	get canSubmit(): boolean {
		const anyActioned = this.rejectedCount > 0 || this.approvedCount > 0;
		// const allActioned = this.pendingCount === 0;
		const reasonProvided = !this.hasRejections || this.rejectionReason?.trim().length > 0;
		return anyActioned && reasonProvided;
	}
}
